import classNames from 'classnames'

import { CommonQuotationIcon, ReviewStar2Icon } from '@local/assets/icons'

import Image from '@web/components/Image'
import { ReviewTab_ReviewGroupCard_ReviewGroupFragment } from '@web/gql/graphql'
import { extractByTypename } from '@web/libs/apollo/typeGuard'
import photoInfra from '@web/libs/media/photoInfra'

import styles from './ReviewGroupCard.module.scss'
import ReviewGroupVideoCard from './ReviewGroupVideoCard'

type Props = {
  reviewGroup: ReviewTab_ReviewGroupCard_ReviewGroupFragment
}

export const ReviewMedia = ({ reviewGroup }: Props) => {
  const { ImageItem, VideoItem } = extractByTypename(reviewGroup.coverMediaItems[0])

  return (
    <div className={styles.img_area}>
      {ImageItem && ImageItem?.url && (
        <Image
          className={styles.img}
          src={ImageItem?.url}
          thumbnailType={photoInfra.type.f510_510_70_sharpen}
          width="100%"
          height="100%"
          alt={`${reviewGroup.place?.name} 리뷰`}
        />
      )}
      {VideoItem && <ReviewGroupVideoCard videoItem={VideoItem} />}
    </div>
  )
}

export const ReviewText = ({ reviewGroup }: Props) => {
  return (
    <>
      <div className={styles.img_area}>
        <div className={styles.img} />
      </div>
      <div className={styles.review_area}>
        <div className={styles.inner}>
          <CommonQuotationIcon className={styles.icon_quote} aria-hidden="true" />
          <span className={styles.txt}>{reviewGroup.text}</span>
        </div>
      </div>
    </>
  )
}

export const ReviewKeyword = ({ reviewGroup }: Props) => {
  return (
    <>
      <div className={styles.img_area}>
        <div className={styles.img} />
      </div>
      <div className={styles.review_area}>
        <div className={styles.inner}>
          <span className={styles.keyword}>
            <img
              className={styles.img}
              src={reviewGroup.votedKeywords[0].icon ?? undefined}
              width="16"
              height="16"
              alt=""
            />
            {reviewGroup.votedKeywords[0].text.korean}
          </span>
          {/* 키워드 리뷰가 더 있는 경우 br 구조 포함 */}
          {reviewGroup.votedKeywords.length > 1 && (
            <>
              <br />
              <span className={classNames(styles.keyword, styles.type_more)}>
                +{reviewGroup.votedKeywords.length - 1}
              </span>
            </>
          )}
        </div>
      </div>
    </>
  )
}

export const ReviewRating = ({ reviewGroup }: Props) => {
  return (
    <>
      <div className={styles.img_area}>
        <div className={styles.img} />
      </div>
      <div className={styles.review_area}>
        <div className={styles.inner}>
          <ReviewStar2Icon className={styles.icon_rating} aria-hidden="true" />
          {reviewGroup.rating}
        </div>
      </div>
    </>
  )
}
